import {gsap, ScrollTrigger} from "../LibrariesImport";
export default class BlockStage {
	static init() {

		let container = document.querySelector(".block-stage");

		if(!container){
			return;
		}


		if( ScrollTrigger.isTouch ) {
			return;
		}

		let header = document.querySelector('.header-main');
		let stagesTitle = container.querySelector('.title');
		let stages = container.querySelectorAll('.stage-item');
		let mm = gsap.matchMedia();

		mm.add("(min-width: 768px)", () => {

			stages.forEach( (stage) => {

				gsap.set(stage, {
					height : window.innerHeight - stagesTitle.offsetHeight - header.offsetHeight
				});

				ScrollTrigger.create({
					trigger: stage,
					pin: true,
					start: "center center",
					endTrigger: stages[stages.length - 1],
					end: "center center",
					pinSpacing: false
				});

			});

		});

		mm.add("(max-width: 768px)", () => {

			stages.forEach( (stage) => {

				gsap.set(stage, {
					height: "auto"
				});

			});

		});

	}
}
